module.exports = {"140202001":"南关街道","140202002":"北关街道","140202003":"东街街道","140202004":"西街街道","140202005":"南街街道","140202006":"北街街道","140202007":"新建南路街道","140202008":"新建北路街道","140202009":"大庆路街道","140202010":"新华街街道","140202011":"西花园街道","140202012":"老平旺街道","140202013":"向阳里街道","140202014":"振华南街街道","140202015":"开源街街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140202.json
// module id = 240
// module chunks = 0